import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { AdminService } from '../../_services/admin.service';
import { Log } from 'ng2-logger';
import { ActivatedRoute, Router } from '@angular/router';
import { Driver } from '../../_models/driver';
import { environment } from '../../../environments/environment';
import { ACLFeature } from '../../_models/acl-feature';

const log = Log.create('DriverDetail');

@Component({
  moduleId: module.id,
  selector: 'edit-driver',
  styleUrls: ['driver.less'],
  templateUrl: 'driver.component.html',
})
export class DriverComponent implements OnInit {
  driver: Driver = new Driver;
  BASE_URL: string = environment.BASE_URL;
  possibleCapabilities: any;
  possibleDimmingTypes: any;
  possibleMountingTypes: any;
  possibleCertifications: any;
  possibleFeatures: any;
  possibleInputVoltages: any;
  possibleIsolationClasses: any;
  possibleDriverClassifications: any;
  possibleVoltageTypes: any;
  possibleDriverFamilies: any;
  possibleDriverFamilyNames: any;
  possibleSensorApplications: any;
  possibleSensorFeatures: any;
  parentId: number;
  parentParams: any;
  urlOptions: any = {};

  iCanMaintenanceMode: boolean = false;
  readOnly: boolean = true;
  iCanArchive: boolean = false;
  iCanViewArchive: boolean = false;
  iCanReadTags: boolean = false;
  iCanWriteTags: boolean = false;

  inchHeight: any;
  inchWidth: any;
  inchLength: any;

  tagFamilies: Array<any> = [];
  activeTagFamily: any = null;
  tags: Array<any> = [];

  piPoDates: Array<any> = [];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private admin: AdminService,
              private toast: ToastsManager) {}

  ngOnInit() {
    this.driver.family = {};
    this.driver.housing = {};

    this.admin.canI(ACLFeature.MAINTENANCE_MODE_ADMIN).subscribe((iCan: boolean) => {
      this.iCanMaintenanceMode = iCan;
    });

    this.admin.canI(ACLFeature.VIEW_ARCHIVE_IN_ADMIN).subscribe((iCan: boolean) => {
      this.iCanViewArchive = iCan;
    });

    this.admin.canI(ACLFeature.ARCHIVE).subscribe((iCan: boolean) => {
      this.iCanArchive = iCan;
    });

    this.admin.canI(ACLFeature.WRITE_DRIVERS).subscribe((iCan: boolean) => {
        this.readOnly = !iCan;
    });

    this.admin.canI(ACLFeature.WRITE_TAGS).subscribe((iCan: boolean) => {
      this.iCanWriteTags = iCan;
    });

    this.admin.canI(ACLFeature.READ_TAGS).subscribe((iCan: boolean) => {
      this.iCanReadTags = iCan;
    });

    // get driver controller data
    this.route.params.subscribe(params => {
      this.admin.getDriverController(params['id']).subscribe((response) => {

        this.parentParams = this.route.snapshot.parent.params;
        this.parentId = this.route.snapshot.parent.params['parentId'];
        this.urlOptions.parentId = this.parentId;
        this.driver = response.data;

        log.d('getDriverController response', response);

        // set models
        this.inchHeight = (this.driver.housing.height * 0.0393700787).toFixed(2);
        this.inchLength = (this.driver.housing.length * 0.0393700787).toFixed(2);
        this.inchWidth = (this.driver.housing.width * 0.0393700787).toFixed(2);

        this.admin.getDriverCapabilities().subscribe((res) => {
          this.possibleCapabilities = res.data;
        });

        this.admin.getDimmingTypes().subscribe((res) => {
          this.possibleDimmingTypes = res.data;
        });

        this.admin.getCertifications().subscribe((res) => {
          this.possibleCertifications = res.data;
        });

        this.admin.getMountingTypes().subscribe((res) => {
          this.possibleMountingTypes = res.data;
        });

        this.admin.getFeatures().subscribe((res) => {
          this.possibleFeatures = res.data;
        });

        this.admin.getInputVoltages().subscribe((res) => {
          this.possibleInputVoltages = res.data;
        });

        this.admin.getIsolationClasses().subscribe((res) => {
          this.possibleIsolationClasses = res.data;
        });

        this.admin.getDriverClassifications().subscribe((res) => {
          this.possibleDriverClassifications = res.data;
          this.possibleDriverClassifications.push({
            name: 'None',
            id: null
          });
        });

        this.admin.getVoltageTypes().subscribe((res) => {
          this.possibleVoltageTypes = res.data;
          this.possibleVoltageTypes.push({
            name: 'None',
            id: null
          });
        });

        this.admin.getDriverFamilies().subscribe((res) => {
          this.possibleDriverFamilyNames = res.data.map(family => {
            return {
              id: family.id,
              text: family.treeName
            };
          });

          this.possibleDriverFamilies = res.data;
        });

        this.admin.getSensorApplications().subscribe((res) => {
          this.possibleSensorApplications = res.data;
        });

        this.admin.getSensorFeatures().subscribe((res) => {
          this.possibleSensorFeatures = res.data;
        });


        this.admin.getTagFamiliesController().subscribe((res) => {
          this.tagFamilies = res.map((item) => {
            return {id: item.id, text: item.name};
          });

          if (this.tagFamilies.length > 0) {
            this.selectedDriverTagFamily(this.tagFamilies[0]);
          }
        });
      });
    });
  }

  public selectedDriverTagFamily(tagFamily) {
    this.admin.getTagFamilyController(tagFamily.id).subscribe((res) => {
      this.activeTagFamily = { id: res.id, text: res.name };
      this.tags = res.tags;
    });
  }

  public selectedDriverFamilyId(value)    { this.setDriverFamilyName(value, 'family'); }
  public selectedDriverFamilyNaId(value)  { this.setDriverFamilyName(value, 'familyNa'); }
  public selectedDriverFamilySaId(value)  { this.setDriverFamilyName(value, 'familySa'); }
  public selectedDriverFamilyCnId(value)  { this.setDriverFamilyName(value, 'familyCn'); }
  public selectedDriverFamilyRoaId(value) { this.setDriverFamilyName(value, 'familyRoa'); }

  public setDriverFamilyName(value, modelName) {
    const driverFamilyIndex = this.possibleDriverFamilies.findIndex(family => family.id === value.id);
    this.driver[modelName] = this.possibleDriverFamilies[driverFamilyIndex];
  }

  public preselectedDropdownTagFamilyValue() {
    if (!this.tagFamilies.length) {
      return [];
    } else if (null != this.activeTagFamily) {
      return [this.activeTagFamily];
    } else {
      return [this.tagFamilies[0]];
    }
  }

  public preselectedDropdownValue(modelName) {
    if (!this.driver[modelName]) {
      return [{
        text: 'None',
        id: 'None'
      }];
    }
    if (this.driver[modelName].treeName) {
      return [{
        text: this.driver[modelName].treeName,
        id: this.driver[modelName].id
      }];
    }
    return [{
      text: this.driver[modelName].name,
      id: this.driver[modelName].id
    }];
  }

  private mmToInch($event) {
      const mm = $event.target.value;
      this.driver.housing.heightInch = (this.driver.housing.height * 0.0393700787).toFixed(3);
      this.driver.housing.lengthInch = (this.driver.housing.length * 0.0393700787).toFixed(3);
      this.driver.housing.widthInch = (this.driver.housing.width * 0.0393700787).toFixed(3);
  }

  private inchToMm($event) {
    const inch = $event.target.value;
    this.driver.housing.height = (this.driver.housing.heightInch * 25.4).toFixed(1);
    this.driver.housing.length = (this.driver.housing.lengthInch * 25.4).toFixed(1);
    this.driver.housing.width = (this.driver.housing.widthInch * 25.4).toFixed(1);
  }

  private onCancel() {
    if (this.parentParams['showArchived'] != null) {
      this.urlOptions.showArchived = this.parentParams['showArchived'];
    }
    this.router.navigate(['/drilldown/drivers', this.urlOptions]);
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this.driver[input.model] = input.updatedData;
  }

  private checkDimmingType(dimmingType) {
    for (const selectedDimmingType of this.driver.dimmingTypes) {
      if (dimmingType.id === selectedDimmingType.id ) {
        return true;
      }
    }
  }

  private updatePiPoModel(input) {
    const newDate = new Date(input.updatedData);

    if (!isNaN(newDate.getTime()) || input.updatedData === '') {
      const piPoIndex = this.piPoDates.findIndex(x => x.model === input.model);
      if (piPoIndex !== -1) {
        this.piPoDates[piPoIndex] = {model: input.model, updatedDate: input.updatedData};
      } else {
        this.piPoDates.push({model: input.model, updatedDate: input.updatedData});
      }
    }
  }

  private onSubmit() {
    log.d('onSubmit fired');

    if (this.numberOfSelectedFamilies() === 0) {
      this.toast.error('Please select at least one driver family!');
      return;
    }

    if (this.isVisibleSomewhere() && !this.driver["image"]) {
      this.toast.error('To make the product visible, please provide an image for the driver!');
      return;
    }

    this.piPoDates.map((piPoDate) => {
      this.driver[piPoDate.model] = piPoDate.updatedDate;
    });

    this.admin.postDriverController(this.driver.id, this.driver).subscribe((response) => {
      this.toast.success(`Changes have been saved.`);
      log.d('postDriverController', 'post succesfull', response);

      if (this.parentParams['showArchived'] != null) {
        this.urlOptions.showArchived = this.parentParams['showArchived'];
      }
      this.urlOptions.refresh = Date.now();
      this.router.navigate(['/drilldown/drivers', this.urlOptions]);
    });
  }

  private numberOfSelectedFamilies(): number {

    let sum = 0;

    sum = sum + (this.driver['family'] ? 1 : 0);
    sum = sum + (this.driver['familyNa'] ? 1 : 0);
    sum = sum + (this.driver['familySa'] ? 1 : 0);
    sum = sum + (this.driver['familyCn'] ? 1 : 0);
    sum = sum + (this.driver['familyRoa'] ? 1 : 0);

    return sum;
  }

  public multiCurrentMarkDelete(index: number) {
    this.driver.multiCurrents[index].id = -2;
  }

  public multiCurrentUpdateValue(index: number, key: string, newValue: string) {
    this.driver.multiCurrents[index][key] = newValue;
  }

  public multiCurrentNew() {
    this.driver.multiCurrents.push({
      id: -1,
      ocMax: 0,
      ocMin: 0,
      opMax: 0,
      opMin: 0,
      ovMax: 0,
      ovMin: 0,
    });
  }

  private isVisibleSomewhere(): boolean {
    return this.driver.viewStatus == "1" ||
      this.driver.viewStatusNa == "1" ||
      this.driver.viewStatusSa == "1" ||
      this.driver.viewStatusCn == "1" ||
      this.driver.viewStatusRoa == "1";
  }
}



// WEBPACK FOOTER //
// ./src/app/drivers/driver/driver.component.ts